// components/PrayerDisplay/SalahProgressOverlay.jsx
import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
// import { FaMosque } from "react-icons/fa";

const SalahProgressOverlay = ({ nextEvent, timezone }) => {
  const [currentTime, setCurrentTime] = useState(moment.tz(moment(), timezone));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment.tz(moment(), timezone));
    }, 1000);
    return () => clearInterval(interval);
  }, [timezone]);

  const prayerName = nextEvent?.name || "PRAYER";

  // Split time and AM/PM for styling separately
  const timePart = currentTime.format("h:mm");
  const meridiem = currentTime.format("A");

  useEffect(() => {
    //console.log("🕌 [SalahProgressOverlay] Active for:", prayerName, "at", currentTime.format("h:mm:ss A"));
  }, [currentTime, prayerName]);

  return (
    <div className="fixed inset-0 z-50 bg-gradient-to-b bg-black flex flex-col items-center justify-center text-white">
      {/* Time Display */}
      <div className="absolute top-4 left-4 flex items-end space-x-1">
        <span className="text-[6svh] font-bold leading-none">{timePart}</span>
        <span className="text-[4svh] ml-[2svh] font-semibold leading-tight self-end">
          {meridiem}
        </span>
      </div>

      {/* <FaMosque className="text-[12rem] text-green-400 animate-bounce mb-8" /> */}
      
      <div className="text-[8svh] uppercase mb-4">
        Salah in Progress ...
      </div>

      {/* <div className="text-3xl font-medium text-yellow-400 uppercase"> */}
        {/* {prayerName} */}
      {/* </div> */}
    </div>
  );
};

export default SalahProgressOverlay;